"use client";

import Image from 'next/image';

interface LogoProps {
  variant?: 'desktop' | 'mobile';
  className?: string;
}

export default function Logo({ variant = 'desktop', className = '' }: LogoProps) {
  if (variant === 'mobile') {
    return (
      <Image
        src="/logo-mobile.svg?v=2"
        alt="Interface Audit"
        width={93}
        height={108}
        className={className}
        priority
        unoptimized
      />
    );
  }

  return (
    <Image
      src="/logo-interfaceaudit.svg?v=2"
      alt="Interface Audit"
      width={370}
      height={108}
      className={className}
      priority
      unoptimized
    />
  );
}
